import {NOTIFICATIONS_RECEIVED, NOTIFICATIONS_REMOVE, NOTIFICATIONS_RESET} from '../types';

export const receiveNotification = notification => ({
    type: NOTIFICATIONS_RECEIVED,
    payload: notification,
});

export const resetNotification = () => ({
    type: NOTIFICATIONS_RESET,
});

export const deleteNotification = id => ({
    type:NOTIFICATIONS_REMOVE,
    payload:id,
})